var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('Card',{attrs:{"cardData":_vm.userCard.card,"clickable":_vm.isClickable,"highlight":_vm.isHighlighted},nativeOn:{"click":function($event){return _vm.handleSelect($event)}}})}
var staticRenderFns = []

export { render, staticRenderFns }